import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Weight: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m657.47 660h-534.94l59.58-390h351.35c17.92 0 35.27 6.43 48.86 18.1s22.57 27.86 25.28 45.57l49.86 326.33zm-500-30h465.07l-44.58-291.79c-3.38-22.14-22.09-38.2-44.48-38.2h-325.6l-50.42 330z' />
    <path d='m390 300c-49.63 0-90-40.37-90-90s40.37-90 90-90 90 40.37 90 90-40.37 90-90 90zm0-150c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z' />
  </IconBase>
));

Weight.displayName = 'Weight';

export default Weight;
